import { useMutation } from 'react-query';
import { sendEmergencyMessage } from '@/utils/graphqlApis';
import { useRecoilValue } from 'recoil';
import { authState } from '@/recoil/auth';

const useSendEmergencyMessage = () => {
  const { token } = useRecoilValue(authState);

  return useMutation(
    (request: {
      orderId: string;
      pharmacyPhone: string;
      reason: string;
      reasonId: string;
    }) => sendEmergencyMessage(request, token)
  );
};

export default useSendEmergencyMessage;
